export const OH_AVAILABLE = 'AVAILABLE';
export const OH_AVLQTY = '';
export const OH_2 = 'Out of Stock';
export const OH_3 = 'Currently Unavailable';
export const OH_6 = 'AVL 24/48 HR';

// export const IMAGE_PLACEHOLDER = 'https://via.placeholder.com/500';
// export const THUMB_IMAGE_PLACEHOLDER = 'https://via.placeholder.com/150';

// export const IMAGE_PLACEHOLDER = 'https://res.cloudinary.com/dms-systems/image/upload/v1652110894/DMS-Auto/Manufacturer/DMS-Logo.png';
export const IMAGE_PLACEHOLDER = 'https://res.cloudinary.com/dms-systems/image/upload/v1652110894/DMS-Auto/Manufacturer/DMS-Logo-TEMP-REPLACE-AFTER-DEMO.png';
export const THUMB_IMAGE_PLACEHOLDER = 'https://res.cloudinary.com/dms-systems/image/upload/v1652110894/DMS-Auto/Manufacturer/DMS-Logo-TEMP-REPLACE-AFTER-DEMO.png';

/**
 * Image Usage Guide – QwikOrder X2
 */
export const Product_Thumbnail = 150;
export const Product_Detail = 500;
export const Product_Detail_Expanded = 800;
export const Category = 275;
export const Featured_Product = 275;
export const Slider_W = 1350;
export const Slider_H = 315;
export const Tablet_Slider_W = 800;
export const Tablet_Slider_H = 380;
export const Mobile_Slider_W = 510;
export const Mobile_Slider_H = 480;
export const Latest_Products = 150;
export const Category_Featured_Products = 150;
export const Parts_Diagram = 500;
export const PL_Product_BGuide = 230;

// cloudinary meta keys
export const CL_ITEM_GALLERY = 'gallery';
export const CL_META_ITEM_SKU = 'itemsku';
export const CL_META_MFG_CODE = 'mfgcode';
export const CL_META_MFG_NAME = 'mcname';
export const CL_META_CATEGORY_ID = 'DXCD01';
export const CL_META_CATEGORY_ID_2 = 'DXCD02';
export const CL_META_CATEGORY_ID_3 = 'DXCD03';
export const CL_META_CATEGORY_ID_4 = 'DXCD04';
export const CL_META_CATEGORY_ID_5 = 'DXCD05';
export const CL_META_CATEGORY_ID_6 = 'DXCD06';
export const CL_META_CATEGORY_ID_7 = 'DXCD07';
export const CL_META_CATEGORY_ID_8 = 'DXCD08';
export const CL_META_CATEGORY_ID_9 = 'DXCD09';
export const CL_META_CATEGORY_ID_10 = 'DXCD10';
export const CL_META_DIAGRAM_ID = 'partdiagramid';
export const CL_META_GALLERY_SEQ = 'gallery-seq';

// cloudinary resource types
export const CL_METARTYPE_ITEM = 'ie9wevulkph3yqixh2qq';
export const CL_METARTYPE_MFG = 'mhgonu7crsaiip7mjtpp';
export const CL_METARTYPE_CATEGORY = 'meoy8ts4gsenmmpgeh1p';
export const CL_METARTYPE_PDIAGRAM = 'q6sggxqsuhj9iz5sodh9';
export const CL_METARTYPE_LATEST = 'wyqs1cgvaf3ty6cwawvc';
export const CL_METARTYPE_FEATURED = 'yvd9u8parhbcaobbnd92';
export const CL_METARTYPE_SLIDER = 'ojs0vh0kq6uq3eqcpvqa';
export const CL_METARTYPE_3D = 'agxwec7icdga5ihekqrf';
export const CL_METARTYPE_PARTSLINK = 'qmzs42bwqlhvcv0qdi2a';
export const CL_METARTYPE_CATEGORY_ONLY = 'ALL_LEVEL_1';


/**
 * 
 * ERROR/SUCCESS MESSAGES
 */

export const UPDATED_SHIP_ADDRESS = 'Shipping Details have been updated.';